import React, { FC } from 'react'
import clsx from 'clsx'

import { StandardProps } from '../../types/common'

import { HamburgerIcon } from '../Icons'

import styles from './Toggle.module.scss'

interface ToggleProps extends StandardProps {
  isToggled?: boolean
  shouldAnimate?: boolean
  onToggle?: () => void
}

export const Toggle: FC<ToggleProps> = ({
  children,
  className,
  style,
  isToggled,
  shouldAnimate,
  onToggle,
  testid = 'toggle',
  ...props
}) => {
  return (
    <button
      {...props}
      className={clsx(styles['hds-toggle'], className)}
      style={style}
      onClick={onToggle}
      data-testid={testid}
    >
      <HamburgerIcon />
    </button>
  )
}
